import { Box, Divider, Grid, Typography } from '@mui/material'
import React from 'react'
import TextBox from '../../../common/TextBox'
import { navigation1 } from '../../../../utilityFunctions'

const DeliveryDetails = (props) => {
	const { shipmentData, setShipmentData, handleSetAlert } = props
	const deliveryDetailsList = [
		{ headerName: "Consignment No.", field: 'FormattedLRNO', isInput: false, inputType: "text" },
		{ headerName: "Sender Name", field: 'Sender', isInput: false, inputType: "text" },
		{ headerName: "Shipment Date", field: 'BookingDate', isInput: false, inputType: "text" },
		{ headerName: "Received Date", field: 'ReceiptDate', isInput: false, inputType: "text" },
		{ headerName: "Payment", field: 'PaymentTypeDet', isInput: false, inputType: "text" },
		{ headerName: "Receiver Name", field: 'RecName', isInput: false, inputType: "text" },
		{ headerName: "Total Units Booked", field: 'Unit', isInput: false, inputType: "text" },
		{ headerName: "Total Amount", field: 'NetAmount', isInput: false, inputType: "text" },
		{ headerName: "Received Units", field: 'ReceivedItems', isInput: false, inputType: "text" },
		{ headerName: "Already Delivered Units", field: 'DeliveredItems', isInput: false, inputType: "number" },
		{ headerName: "From", field: 'BookingCounter', isInput: false, inputType: "text" },
		{ headerName: "Units To Deliver", field: 'PendingDeliveyItems', isInput: true, inputType: "number", disabled: false },
		{ headerName: "To", field: 'DestinationCounter', isInput: false, inputType: "text" },
		{ headerName: "Received By", field: 'ReceivedBy', isInput: true, inputType: "text" },
		{ headerName: "Demurrage Charge", field: 'DemurrageChg', isInput: false, inputType: "number" },
		{ headerName: "Receiver Phone No. ", field: 'RecMobileNo', isInput: true, inputType: "number" },
		{ headerName: "", field: '', isInput: false, inputType: "number", isEmpty: true },

		{ headerName: "Remarks", field: 'Remarks', isInput: true, inputType: "text" },
	]
	return (
		<Box sx={{ paddingX: "16px" }}>
			<Box
				sx={{
					display: "flex",
					alignItems: "center",
					paddingY: "16px",
					gap: "10px",
				}}
			>
				<Typography
					sx={{
						marginRight: 2,
						fontWeight: "600",
						fontSize: "16px",
						color: "#004F9E",
						textTransform: "uppercase",
					}}
				>
					DeliverY Details
				</Typography>
				<Divider sx={{ flexGrow: 1, borderColor: "#004F9E" }} />
			</Box>
			<Grid
				container
				direction="row"
				justifyContent="space-between"
				flexWrap={"wrap"}
				alignItems="center"
				columnSpacing={{ xs: "6px" }}
				rowSpacing={{ xs: "8px" }}
				className="TextBold"
			>
				{deliveryDetailsList?.map((obj, i, d) => {
					const { length } = d;
					const last = length - 1 === i;
					const prev =
						obj?.field === "ReceivedBy"
							? "searchButton"
							: d[i - 2]?.field + (i - 2);
					const next = last
						? "deliverybutton"
						: d[i + 2]?.field + (i + 2);
					return (
						<>
							{obj?.isEmpty ?
								<Grid
									item
									md={6}
									sx={{ display: "flex", alignItems: "center" }}
								>
								</Grid>
								:
								<Grid
									item
									md={6}
									sx={{ display: "flex", alignItems: "center" }}
								>
									<Typography
										sx={{ width: "40%", height: "40px" }}
									>
										{obj?.headerName}
									</Typography>
									{obj?.isInput ? (
										<Box sx={{ width: "60%" }}>
											<TextBox
												type={obj?.inputType}
												value={shipmentData[obj?.field]}
												onChange={({
													target: { value, name },
												}) => {
													setShipmentData({
														...shipmentData,
														[name]: value,
													});
												}}
												onBlur={(e) => {
													if(e.target.name==='PendingDeliveyItems' && e.target.value<=0){
														handleSetAlert(`Units to Deliver cannot be less than or equal to 0`);
	
													}else if(e.target.name==='PendingDeliveyItems'&& e.target.value>(shipmentData?.ReceivedItems-shipmentData?.DeliveredItems)){
														handleSetAlert(`Units to Deliver cannot be greater than  ${shipmentData?.ReceivedItems-shipmentData?.DeliveredItems}`);
													}
												}}
												maxLength={obj?.field === 'RecMobileNo' ? 10 : ""}
												name={obj?.field}
												label={""}
												disabled={obj?.disabled || false}
												onKeyDown={(e) =>
													navigation1(e, next, prev)
												}
											/>
										</Box>
									) : (
										<span>
											:&nbsp;{shipmentData[obj?.field]}
										</span>
									)}
								</Grid>
							}
						</>
					);
				})}
			</Grid>
		</Box>
	);
}

export default DeliveryDetails